import Image from '../../../../../assets/image.svg';

const ImageButton = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Image {...props} />;
};

export default ImageButton;
